import { createListPage, createDetailPage } from 'pages/common'
import { api, actionCreators } from 'store/modules/storagePlaces'
import Content from './grid'
import Form from './form'

import { urls } from 'urls'

const PAGE = 'storagePlaces'

export const metadata = {
  icon: 'archive',
  page: PAGE,
  isSoftDelete: false,
  urls: urls[PAGE]
}

const StoragePlacesListPage = createListPage({ metadata, api, actionCreators, Content })
const StoragePlacesDetailPage = createDetailPage({ metadata, actionCreators, Form })

export { StoragePlacesListPage, StoragePlacesDetailPage }
